export const scssPattern = `@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

// Breakpoints
$breakpoint-xs: 0;
$breakpoint-sm: 576px;
$breakpoint-md: 768px;
$breakpoint-lg: 992px;
$breakpoint-xl: 1200px;
$breakpoint-xxl: 1400px;

body.carousel-active {
    overflow-y: hidden !important;
}

.gallery,
.carousel {
    font-family: "Quicksand", sans-serif !important;
    font-weight: 500;
    box-sizing: border-box;
    & * {
        box-sizing: border-box;
    }
}

.gallery {
    transition: all 0.5s ease-in-out;
    & img-item {
        display: block;
    }
}

.gallery.row.left {
    justify-content: flex-start;
}

.gallery.row.right {
    justify-content: flex-end;
}

.gallery.row {
    width: 100%;
    height: auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    & .item {
        width: 300px;
        height: 200px;
        & img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        & img:hover {
            cursor: pointer;
            opacity: 0.85;
        }
    }
}

.gallery.masonry {
    column-gap: 30px;
    column-fill: initial;
    & .item {
        margin-bottom: 30px;
        & img {
            transition: all 0.5s ease-in-out;
            backface-visibility: hidden;
            width: 100%;
            height: auto;
            vertical-align: middle;
        }
        & img:hover {
            cursor: pointer;
            opacity: 0.85;
        }
    }
}

.gallery.masonry.bordered {
    column-rule: 1px solid black;
    column-gap: 50px;
    & .item {
        margin-bottom: 25px;
    }
}

.gallery.masonry.no-gutter {
    column-gap: 0;
    & .item {
        margin-bottom: 0;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .gallery.masonry {
        column-count: 2;
    }
}

@media (min-width: 1024px) {
    .gallery.masonry {
        column-count: 3;
    }
}

.carousel.active {
    display: block;
}

.carousel {
    position: relative;
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    margin: 0;
    padding: 0;
    z-index: 199;
    & .caption-container {
        & .caption-item {
            display: none;
            & .caption-msg {
                display: block;
                color: #f2f2f2;
                background-color: rgba(0, 0, 0, 0.4);
                font-size: 20px;
                position: absolute;
                bottom: 5%;
                left: 0;
                width: 100%;
                text-align: center;
            }
            & .caption-number {
                display: block;
                color: black;
                background-color: rgba(255, 255, 255, 0.8);
                font-size: 16px;
                padding: 8px 12px;
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 10px;
            }
        }
    }
    & .img-container {
        display: block;
        // border: 3px solid wheat;
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        & .img-slide {
            display: none;
            & img {
                display: block;
                width: auto;
                max-width: 100%;
                height: auto;
                max-height: 100vh;
                object-fit: contain;
                object-position: center;
                margin: auto;
            }
        }

        & .fade {
            animation: fade 0.5s linear;
        }
    }
    @media (max-width: $breakpoint-lg) {
        .img-container {
            width: 100%;
        }
    }
    & .prev,
    & .next {
        cursor: pointer;
        position: absolute;
        top: 50%;
        width: auto;
        padding: 16px;
        margin-top: -22px;
        color: white;
        font-weight: bold;
        font-size: 40px;
        transition: 0.6s ease;
        border-radius: 0 3px 3px 0;
        user-select: none;
        z-index: 100;
    }
    & .prev {
        left: 20px;
    }
    & .next {
        right: 20px;
        border-radius: 3px 0 0 3px;
    }
    & .prev:hover,
    & .next:hover {
        color: #717171;
        transform: scale(1.3);
    }
    & .close {
        position: absolute;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: black;
        top: 0;
        right: 0;
        z-index: 2;
        background-color: rgba(255, 255, 255, 0.8);
        padding: 5px 15px;
        border-radius: 10px;
        font-weight: bold;
        font-size: 24px;
    }
    & .close:hover {
        cursor: pointer;
    }
    & .dot-container {
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        & .dot {
            cursor: pointer;
            height: 15px;
            width: 15px;
            margin: 0 3px;
            padding: 0 8px;
            background-color: white;
            border-radius: 50%;
            display: inline-block;
            transition: background-color 0.6s ease;
        }
        & .active,
        & .dot:hover {
            background-color: #717171;
            border: 2px solid white;
            padding: 2px 0;
            transform: scale(1.3);
            color: white;
        }
    }
    @media (max-width: 675px) {
        & .dot-container {
            display: none;
        }
        & .caption-container {
            & .caption-item {
                & .caption-msg {
                    bottom: 1%;
                }
            }
        }
        & .img-container {
            width: 100%;
        }
    }
    @media (max-height: 600px) {
        & .dot-container {
            display: none;
        }
    }
}`

export const cssPattern = `@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");
body.carousel-active {
    overflow-y: hidden !important;
}
.gallery,
.carousel {
    font-family: "Quicksand", sans-serif !important;
    font-weight: 500;
    box-sizing: border-box;
}
.gallery *,
.carousel * {
    box-sizing: border-box;
}
.gallery {
    transition: all 0.5s ease-in-out;
}
.gallery img-item {
    display: block;
}
.gallery.row.left {
    justify-content: flex-start;
}
.gallery.row.right {
    justify-content: flex-end;
}
.gallery.row {
    width: 100%;
    height: auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
}
.gallery.row .item {
    width: 300px;
    height: 200px;
}
.gallery.row .item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.gallery.row .item img:hover {
    cursor: pointer;
    opacity: 0.85;
}
.gallery.masonry {
    column-gap: 30px;
    column-fill: initial;
}
.gallery.masonry .item {
    margin-bottom: 30px;
}
.gallery.masonry .item img {
    transition: all 0.5s ease-in-out;
    backface-visibility: hidden;
    width: 100%;
    height: auto;
    vertical-align: middle;
}
.gallery.masonry .item img:hover {
    cursor: pointer;
    opacity: 0.85;
}
.gallery.masonry.bordered {
    column-rule: 1px solid black;
    column-gap: 50px;
}
.gallery.masonry.bordered .item {
    margin-bottom: 25px;
}
.gallery.masonry.no-gutter {
    column-gap: 0;
}
.gallery.masonry.no-gutter .item {
    margin-bottom: 0;
}
@media (min-width: 768px) and (max-width: 1023px) {
    .gallery.masonry {
        column-count: 2;
    }
}
@media (min-width: 1024px) {
    .gallery.masonry {
        column-count: 3;
    }
}
.carousel.active {
    display: block;
}
.carousel {
    position: relative;
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    margin: 0;
    padding: 0;
    z-index: 199;
}
.carousel .caption-container .caption-item {
    display: none;
}
.carousel .caption-container .caption-item .caption-msg {
    display: block;
    color: #f2f2f2;
    background-color: rgba(0, 0, 0, 0.4);
    font-size: 20px;
    position: absolute;
    bottom: 5%;
    left: 0;
    width: 100%;
    text-align: center;
}
.carousel .caption-container .caption-item .caption-number {
    display: block;
    color: black;
    background-color: rgba(255, 255, 255, 0.8);
    font-size: 16px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
}
.carousel .img-container {
    display: block;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.carousel .img-container .img-slide {
    display: none;
}
.carousel .img-container .img-slide img {
    display: block;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100vh;
    object-fit: contain;
    object-position: center;
    margin: auto;
}
.carousel .img-container .fade {
    animation: fade 0.5s linear;
}
@media (max-width: 992px) {
    .carousel .img-container {
        width: 100%;
    }
}
.carousel .prev,
.carousel .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    padding: 16px;
    margin-top: -22px;
    color: white;
    font-weight: bold;
    font-size: 40px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
    z-index: 100;
}
.carousel .prev {
    left: 20px;
}
.carousel .next {
    right: 20px;
    border-radius: 3px 0 0 3px;
}
.carousel .prev:hover,
.carousel .next:hover {
    color: #717171;
    transform: scale(1.3);
}
.carousel .close {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: black;
    top: 0;
    right: 0;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 5px 15px;
    border-radius: 10px;
    font-weight: bold;
    font-size: 24px;
}
.carousel .close:hover {
    cursor: pointer;
}
.carousel .dot-container {
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -50%);
}
.carousel .dot-container .dot {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0 3px;
    padding: 0 8px;
    background-color: white;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
}
.carousel .dot-container .active,
.carousel .dot-container .dot:hover {
    background-color: #717171;
    border: 2px solid white;
    padding: 2px 0;
    transform: scale(1.3);
    color: white;
}
@media (max-width: 675px) {
    .carousel .dot-container {
        display: none;
    }
    .carousel .caption-container .caption-item .caption-msg {
        bottom: 1%;
    }
    .carousel .img-container {
        width: 100%;
    }
}
@media (max-height: 600px) {
    .carousel .dot-container {
        display: none;
    }
}`